<template lang="pug">
v-container(fluid).pa-0.align-content-center
  v-sheet(max-width="29.7cm").mx-auto.overflow-hidden
    v-row(no-gutters)
    v-chip-group(
      v-model="chip"
      mandatory column
      active-class="secondary"
    )
      v-chip.mr-2.mb-1(
        v-for="i in typeAttrs.items"
        :value="i.value"
        color="" depressed
        :disabled="i.disabled"
      )
        v-icon(v-if="i.disabled" left small) mdi-lock
        span {{ i.text }}
  .d-flex

  v-sheet.sdo-shadow.ma-auto.mb-10.mt-2.sdo-radius.overflow-hidden.border(
    v-if="!loading && settings"
    width="29.7cm"
  )
    v-app-bar(height="48" elevation="0" color="secondary")
      v-btn(color="white" depressed outlined small @click="openImageEdit('background')")
        v-icon(left) mdi-pencil
        span Изменить фон
      v-btn.ml-auto(color="success" @click="generate" fab depressed x-small): v-icon mdi-check

    v-img(
      :lazy-src="require('@/assets/background_diploma_default.jpg')"
      :src=`settings.background
        ? settings.background.url
        : require('@/assets/background_diploma_default.jpg')
      `
      width="29.7cm"
      height="21cm"
    )
      v-row(no-gutters)
        v-col(cols="6").relative
          .fill-width.pl-10(
            style="position: absolute; top: 25mm;"
          )
            .mx-auto.px-16.py-2.sdo-radius.relative.input-hover(
              style="width: 110mm; max-height: 100px; border: 2px dashed grey; cursor: pointer;"
              @click="openImageEdit('logo_left')"
            )
              v-img.pa-2(
                :src=`settings.logo_left
                  ? settings.logo_left.url
                  : require('@/assets/logo-dark.svg?inline')
                `
                width="75mm" contain
                max-height="80px"
              )
              v-icon(
                small color="secondary" style="position: absolute; top: 10px; right: 10px"
              ) mdi-pencil
            .font.style.mt-2.text-center
              .mb-4.text-h4.font: strong Удостоверение
              .mb-4.text-body-2.font: strong о повышении квалификации
              .mb-8.text-h5.font: strong ПК 000001

              .mb-2.text-body-1.font Документ о квалификации
              .mb-5.text-body-1.font Регистрационный номер
              .mb-8: strong AAAA-000001

              .text-body-1.font Город
              .relative
                .mb-6.text-body-1.font.py-1.sdo-radius.input-hover.px-2(
                  contenteditable
                  style="border: 2px dashed grey; cursor: pointer;"
                  @input="payload.city = $event.target.innerText"
                ) {{ settings.city }}
                v-icon(
                  small color="secondary" style="position: absolute; top: 8px; right: 10px"
                ) mdi-pencil

              .mb-4.text-body-1.font Дата выдачи
                strong.ml-2 01.07.2024 г.
              qr-code.d-inline-block.pa-3.white.sdo-radius(
                value="http://localhost:8080/payment-system/certificate-edit"
                size="100"
              )

        v-col(cols="6").relative
          .fill-width.pr-10(style="position: absolute; top: 25mm;")
            .mx-auto.px-16.py-2.sdo-radius.input-hover.relative(
              style="width: 110mm; border: 2px dashed grey; cursor: pointer;"
              @click="openImageEdit('logo_right')"
            )
              v-img.pa-2(
                :src=`settings.logo_right
                  ? settings.logo_right.url
                  : require('@/assets/logo-dark.svg?inline')
                `
                width="75mm" contain
                max-height="80px"
              )
              v-icon(
                small color="secondary" style="position: absolute; top: 10px; right: 10px"
              ) mdi-pencil
            .font.style.mt-4.text-center
              .mb-4 Настоящее удостоверение свидетельствует о том что:
              .mb-10: strong Иванов Иван Иванович
              .mb-4 прошел(а) повышение квалификации в (на)
              .relative
                strong.d-block.mb-9.py-2.sdo-radius.input-hover.px-2(
                  contenteditable
                  style="border: 2px dashed grey; cursor: pointer; line-height: 1"
                  @input="payload.organization_full_name = $event.target.innerText"
                )  {{ settings.organization_full_name || $user.organization.full_name }}
                v-icon(
                  small color="secondary" style="position: absolute; top: 10px; right: 10px"
                ) mdi-pencil
              .mb-10 в сроки с 11.04.2023 г. по 12.04.2024 г.
              .mb-4 по дополнительной профессиональной программе
              .mb-10: strong Название курса
              .mb-10 в объеме
                strong.mx-1.px-1.py-2 102
                span часов
              v-alert.mx-1.text-center(
                height="100px"
                :color="isSignRequired ? 'primary' : 'grey lighten-1'"
                text outlined
                style="cursor: pointer;"
                @click="isSignRequired = !isSignRequired; saveSignRequiredValue(isSignRequired);"
              )
                v-checkbox.pt-0.mt-0.mb-1(
                  v-model="isSignRequired"
                  :disabled="loadingSaveRequired"
                  hide-details label=""
                  @change="saveSignRequiredValue"
                  @click.stop
                )
                  template(#label)
                    .text-body-2: strong Ставить
                strong.mt-2 Подпись ЭЦП
  portal(to="image-edit.dialog" v-slot="{ close, attrs }")
    image-cropper(
      ref="cropper"
      v-model="uploadedImg"
      :aspect-ratio="attrs.type === 'background' ? 297/210 : null"
      :accept="attrs.type !== 'background' ? 'image/svg+xml,' : 'image/*'"
      view-close
      @input="onUpload(attrs.type)"
      @update:url="(val) => setUrl(val, attrs.type)"
    )
      template(#default="{ loading, uploadCropped }")
        v-btn.ma-2.ml-auto(small color="error" outlined) Закрыть
        v-btn.ma-2(
          small
          :loading="loading"
          color="success"
          @click="uploadCropped();"
        ) Сохранить
</template>
<script>
// ??
import ImageCropper from '@/components/InputFields/imageCropper.vue';

import MenuCourseTypeSelect from '../components/MenuCourseTypeSelect.vue';

export default {
  components: {
    MenuCourseTypeSelect,
    ImageCropper,
  },
  data() {
    return {
      uploadedImg: null,
      isSignRequired: false,
      chip: null,
      loading: true,
      loadingSaveRequired: false,
      payload: {
        city: 'Москва',
        background: null,
        organization_full_name: this.$user.organization.full_name,
        logo_left: null,
        logo_right: null,
      },
      settings: null,
    };
  },
  computed: {
    typeAttrs() {
      const TYPES = {
        ADVANCED_TRAINING: 1,
        OF_RETRAININ: 2,
        OF_TRAINING: 3,
      };
      const TYPES_NAMES = {
        [TYPES.ADVANCED_TRAINING]: 'Удостоверение о повышении квалификации',
        [TYPES.OF_RETRAININ]: 'Свидетельство о переподготовке',
        [TYPES.OF_TRAINING]: 'Свидетельство об обучении',
      };

      return {
        items: Object.values(TYPES).map(
          (el) => ({
            value: el,
            text: TYPES_NAMES[el],
            disabled: el !== TYPES.ADVANCED_TRAINING,
          }),
        ),
      };
    },
  },
  async created() {
    const { data } = await this.$api.diploma.getDiplomaSettings({
      expand: 'logo_left,logo_right,background',
      'search[diploma_type]': 1,
      'search[organization_id]': this.$user.organization.id,
    });
    this.settings = data.data[0] ? data.data[0] : { ...this.payload };
    if (data.data[0]) {
      this.payload = {
        city: this.settings.city,
        organization_full_name: this.settings.organization_full_name,
      };
    }
    this.getCourseTypeSettings();
    this.loading = false;
  },
  methods: {
    setUrl(val, type) {
      this.$set(this.settings, type, { url: val });
      this.$modals.close();
      // this.settings[type].url = val;
    },
    onUpload(type) {
      this.payload[type] = this.uploadedImg;
      this.uploadedImg = null;
    },
    openImageEdit(type) {
      this.$modals.show('dialog-portal', {
        inputValue: 'image-edit',
        type,
        dialogProps: {
          width: 600,
        },
      });
    },
    async saveSignRequiredValue(val) {
      this.loadingSaveRequired = true;
      await this.$api.diploma.saveCourseTypeSettings({
        is_sign_required: val, course_type: this.chip,
      });
      this.loadingSaveRequired = false;
    },
    async getCourseTypeSettings() {
      const { data } = await this.$api.diploma.courseTypeSettings({
        'search[course_type]': this.chip,
        'search[organization_id]': this.$user.organization.id,

      });
      const settings = data.data[0];
      this.isSignRequired = settings ? settings.is_sign_required : false;
    },
    async generate() {
      const payload = {
        ...this.payload,
        organization_id: this.$user.organization.id,
        logo_left: this.payload.logo_left,
        logo_right: this.payload.logo_right,
        background: this.payload.background,
        diploma_type: this.chip,
      };
      const method = this.settings.id
        ? (data) => this.$api.diploma.updateDiplomaSettings(this.settings.id, data)
        : (data) => this.$api.diploma.createDiplomaSettings(data);
      await method(payload).then(() => this.$toasted.success('Успешно!'));
    },
  },
};
</script>
<style lang="scss" scoped>
  .font {
    font-family: 'Arial' !important;
    font-style: normal !important;
    font-weight: normal !important;
    line-height : 0.825;
  }
  .style {
    position: relative;
    left: 50%;
    max-width: 108mm;
    transform: translate(-50%, 0);
    padding-top: 1.275rem;
  }
a:hover,
a:focus {
  color: #2a6496;
  text-decoration: underline;
}
  .input-hover:hover::before {
    content: '';
    position: absolute;
    top: 0px;
    border-radius: 20px;
    left: 0px;
    width: 100%;
    height: 100%;
    opacity: 0.2;
    background-color: $secondary-color;
    transition: .1s ease-in-out;
    z-index: -1;
  }

    // @font-face {
    //     font-family : 'Arial';
    //     font-style  : normal;
    //     font-weight : bold;
    //     src         : url({{ storage_path('fonts/arialunibold.ttf') }}) format('truetype');
    // }

  p {
    font-size : 0.925rem;
  }
  .border {
    border-color: var(--v-secondary-base) !important;
  }

    .plural { display : inline-block;}

</style>
